import React from 'react';
import { money } from '../services/swil';
import './OutstandingFigures.css';
export default function OutstandingFigures({ stats }) {
  return <div className="outstanding-figures">
    <span>Open invoices <b>{stats?.openCount ?? '—'}</b></span>
    <span className={stats?.overdueCount > 0 ? 'overdue-red' : ''}>Overdue invoices <b>{stats?.overdueCount ?? '—'}</b></span>
    <span className={stats?.overdueAmount > 0 ? 'overdue-red' : ''}>Overdue · &gt;7 days <b>{stats ? money(stats.overdueAmount) : '—'}</b></span>
    {stats?.unknownDates > 0 && <small>Age unavailable for {stats.unknownDates} invoice(s).</small>}
  </div>;
}

